// General Page
export const HOME = '/';
export const TERMS_OF_USE = '/terms-of-use';
export const PRIVACY_POLICY = '/privacy-policy';
export const NOT_FOUND = '/notfound';

export const GET_DEMO = '/get-demo';
export const TRY_RISK_FREE = '/try-risk-free';

export const LINKED_IN_URL = 'https://www.linkedin.com/company/linkedfield/';
export const TWITTER_URL = 'https://twitter.com/LinkedField';
